enum ErrorType {
    JobTitleInEligible = `JOB_TITLE_INELIGIBLE`,
}

interface Error {
    type: ErrorType
    description: string
}

interface ApplicationError {
    error?: string,
    errorDescription?: string,
    errorCode: ErrorCode
}

enum ErrorCode {
    RECORD_NOT_FOUND = `RECORD_NOT_FOUND`,
    UNKNOWN_ERROR = `UNKNOWN_ERROR`,
    UNAUTHENTICATED = `UNAUTHENTICATED`,
    VALIDATION_ERROR = `VALIDATION_ERROR`,
    MULTIPLE_DEVICE_FOUND_ERROR = `MULTIPLE_DEVICE_FOUND_ERROR`,
    DB_ERROR = `DB_ERROR`,
    SIGNUP_FEE_NOT_CONFIGURED = `SIGNUP_FEE_NOT_CONFIGURED`,
    RENEW_FEE_NOT_CONFIGURED = `RENEW_FEE_NOT_CONFIGURED`,
    UCEM_MEMBERSHIP_EXISTS = `UCEM_MEMBERSHIP_EXISTS`,
    RECORD_EXISTS_ACTIVE = `RECORD_EXISTS_ACTIVE`,
    RECORD_EXISTS_DRAFT = `RECORD_EXISTS_DRAFT`,
    OTP_VERIFICATION_FAILED = `OTP_VERIFICATION_FAILED`,
    BATCH_SIZE_EXCEEDED = `BATCH_SIZE_EXCEEDED`,
    ACTIVE_MEMBERSHIP_EXIST = `ACTIVE_MEMBERSHIP_EXIST`,
    CANNOT_PROCEED = `CANNOT_PROCEED`,
    LINKPASS_USER_EXISTS = `LINKPASS_USER_EXISTS`,
    EMAIL_UNAVAILABLE = `EMAIL_UNAVAILABLE`,
    NRIC_UNAVAILABLE = `NRIC_UNAVAILABLE`,
    OTP_EXCEED_TIMES = `OTP_EXCEED_TIMES`,
    MEMBERSHIP_CONNECTION_FAIL = `MEMBERSHIP_CONNECTION_FAIL`,
    MYINFO_ERROR = `MYINFO_ERROR`,
    RETRY_UPFRONT_PAYMENT_FAILED = `RETRY_UPFRONT_PAYMENT_FAILED`,
    UNAUTHENTICATION_REQUEST = `UNAUTHENTICATION_REQUEST`,
    INACTIVE_MEMBERSHIP = `INACTIVE_MEMBERSHIP`
}

enum Status {
    SUCCESS = `SUCCESS`,
    CREATED = `CREATED`,
    BAD_REQUEST = `BAD_REQUEST`,
    RECORD_NOT_FOUND = `RECORD_NOT_FOUND`,
    BUSINESS_ERROR = `BUSINESS_ERROR`,
    SYS_ERROR = `SYS_ERROR`,
    UNAUTHENTICATED = `UNAUTHENTICATED`,
    CONFLICT = `CONFLICT`,
}

export type { Error, ApplicationError }
export { Status, ErrorCode, ErrorType }

